export function constructFormDataParams(
  obj: Record<string, unknown>,
): FormData {
  const _formData = new FormData();

  if (obj && typeof obj === 'object') {
    for (const [key, value] of Object.entries(obj)) {
      if (value !== undefined && value !== null) {
        const formValue =
          value instanceof File || value instanceof Blob
            ? value
            : String(value);
        _formData.append(key, formValue);
      }
    }
  }
  return _formData;
}
